import { FormControl } from '@angular/forms';
import { MarketingPreferencesForm } from '../../models/marketing-preferences/marketing-preferences-form.interface';

export const mockMarketingPreferencesForm: MarketingPreferencesForm = {
  marketingPreferenceEmail: new FormControl(true),
  marketingPreferencePost: new FormControl(true),
  marketingPreferenceTelephone: new FormControl(true),
};
